import { Table } from '@tiptap/extension-table';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';
import { TableRow } from '@tiptap/extension-table-row';

// Inline styling on table elements so borders, padding, and the header background
// reach email clients (where the .rich-text table CSS rule doesn't apply). Hex values
// mirror the gray-4 / gray-5 design tokens used in rich-text.css; keep in sync if the
// tokens change. cellpadding="0" suppresses the email client's default padding so it
// doesn't compound with the style padding; border="1" and bgcolor are fallbacks for
// clients that strip `style`.
const TABLE_STYLE = 'border-collapse: collapse; table-layout: fixed; margin: 0';
const CELL_STYLE = 'border: 1px solid #e1e1e0; padding: 4px 8px; vertical-align: top';
const HEADER_STYLE = `${CELL_STYLE}; background-color: #f7f7f7; font-weight: 600; text-align: left`;

export const buildTableExtensions = () => [
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      border: '1',
      cellpadding: '0',
      cellspacing: '0',
      style: TABLE_STYLE,
    },
  }),
  TableRow,
  TableHeader.configure({ HTMLAttributes: { style: HEADER_STYLE, bgcolor: '#f7f7f7' } }),
  TableCell.configure({ HTMLAttributes: { style: CELL_STYLE } }),
];
